<template>
  <div class="charts_el" ref="chartsEl" v-loading="loading" :style="getWidth()"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "GjkcH5ScoreRadar",
  props: {
    width: {},
    height: {},
  },

  data() {
    return {};
  },

  mounted() {
    // this.initCharts();
  },

  methods: {
    initCharts(correctData) {
      // 数据处理
      const processedData = correctData.map(item => {
        if (item === "-" || item === "" || item === null || item === undefined) {
          return null;
        }
        return typeof item === 'number' ? item : Number(item);
      });

      var chartDom = this.$refs.chartsEl;
      var myChart = echarts.init(chartDom);

      // 销毁之前的图表实例
      myChart.dispose();
      myChart = echarts.init(chartDom);

      var option;

      option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const value = params[0].value;
            const index = params[0].dataIndex;
            const categories = ["超易", "容易", "中档", "困难", "特难"];
            if (value === null || value === undefined) {
              return `${categories[index]}: <span style="color: #999;">-</span>`;
            }
            return `${categories[index]}: <span style="color: #48D8BF; font-weight: bold;">${value}%</span>`;
          }
        },
        xAxis: [
          {
            type: "category",
            data: ["超易", "容易", "中档", "困难", "特难"],
            axisLine: {
              lineStyle: {
                color: "#999",
              },
            },
            axisLabel: {
              color: "#666"
            }
          },
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 5,
            name: "正确率  %",
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#EEE",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: "#666",
              formatter: '{value}%'
            },
            nameTextStyle: {
              color: "#999",
            },
            splitArea: {
              show: false,
            },
            min: 0,
            max: 100
          },
        ],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            name: "正确率",
            type: "line",
            data: processedData,
            connectNulls: true, // 关键：连接空值点
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 4,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#A9F387",
                  },
                  {
                    offset: 1,
                    color: "#48D8BF",
                  },
                ],
              },
              shadowColor: "rgba(72,216,191, 0.3)",
              shadowBlur: 10,
              shadowOffsetY: 5,
            },
            itemStyle: {
              color: "#fff",
              borderWidth: 3,
              borderColor: "#48D8BF",
              shadowColor: "rgba(72,216,191, 0.5)",
              shadowBlur: 5,
            },
            smooth: 0.3, // 平滑度，可以调整
            emphasis: {
              // 高亮样式
              itemStyle: {
                borderWidth: 4,
                borderColor: "#FF6B6B",
                shadowColor: "rgba(255,107,107, 0.5)",
                shadowBlur: 10,
              }
            }
          },
        ],
      };

      option && myChart.setOption(option);

      // 响应式调整
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    },
    getWidth() {
      if (!this.width) return;
      return {
        width: this.width + "px",
        height: this.height + "px",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.charts_el {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
